import { isTokenValid, useToken } from '@ori/auth';
import { BubbleGroup, isECatalogue } from '@ori/basket-bubble-lib';
import { TranslationsProvider } from '@ori/i18n';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { type parseSpaConfig } from '@ori-appshell/config';
import { type FC } from 'react';

import { APP_NAME } from './constants';
import type { AppConfiguration } from './types';
import { getTranslationsProps } from './utils';

export type AppProps = ReturnType<typeof parseSpaConfig>;

export const App: FC<AppConfiguration> = (configuration) => {
  const { currentLanguage, staticApiUrl, tenant } = configuration;
  const { token } = useToken();
  const translationProps = getTranslationsProps({ currentLanguage, staticApiUrl, tenant, token });
  const isCatalogue = isECatalogue();

  if (!isTokenValid(token)) {
    return null;
  }

  return (
    <TestIdProvider
      project={APP_NAME}
      team={Team.Checkout}
    >
      <TranslationsProvider {...translationProps}>
        <BubbleGroup isECatalogue={isCatalogue} />
      </TranslationsProvider>
    </TestIdProvider>
  );
};
